class ErrorHelper {
  static getApiErrorMessage(error) {
    let message = "Server error";
    if (error === undefined || error === "" || error.status === 500) {
      return message;
    } else if (error.data === undefined || error.data === "") {
      return message;
    } else if (error.message !== undefined) {
      message =
        error.message === "Bad credentials"
          ? "Invalid username & password"
          : error.message;
    } else if (error.data.message !== undefined) {
      message = error.data.message;
    } else if (error?.data?.errors !== undefined) {
      message = error.data.errors[0].message;
    }
    return message;
  }
}

export default ErrorHelper;
